import clsx from "clsx";
import { useMemo } from "react";
import { hashIfTooLong, useTranslationEx } from "../../hooks/useTranslationEx";
import { jsonToHtml } from "../../utils/richtextUtil";

export const RichTextBox = ({
  richtext,
  noImage,
  className,
}: {
  richtext?: string;
  noImage?: boolean;
  className?: string;
}) => {
  const { t2 } = useTranslationEx({
    entityType: "Post",
    tlKey: hashIfTooLong(richtext || ""),
  });
  const json = useMemo(() => {
    if (!richtext) return [];
    try {
      return JSON.parse(t2(richtext));
    } catch (e) {
      return [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [richtext, t2]);
  if (!richtext) return null;

  return (
    <div
      className={clsx("richtext-box" + (noImage ? " no-image" : ""), className)}
      dangerouslySetInnerHTML={{
        __html: jsonToHtml(json),
      }}
    />
  );
};

// type NodeType = "tag" | "text";

// interface TextNode {
//   type: "text";
//   text: string;
// }

// interface TagNode {
//   type: "tag";
//   name: string;
//   attributes?: Record<string, any>;
//   children?: Node[];
// }

// type Node = TextNode | TagNode;

// interface JsonToReactProps {
//   json: Node[];
// }

// const renderElement = (node: Node): React.ReactNode => {
//   if (node.type === "text") {
//     return node.text;
//   }

//   if (node.type === "tag") {
//     const { name, attributes = {}, children = [] } = node;
//     const Tag = name as keyof JSX.IntrinsicElements;
//     return (
//       <Tag {...attributes}>
//         {children.map((child, index) => (
//           <React.Fragment key={index}>{renderElement(child)}</React.Fragment>
//         ))}
//       </Tag>
//     );
//   }

//   return null;
// };

// const JsonToReact: React.FC<JsonToReactProps> = ({ json }) => {
//   return <>{json.map((node, index) => renderElement(node))}</>;
// };

// export default JsonToReact;
